const SEARCH_TIMER = 600;

export default SEARCH_TIMER;
